import { Record } from "immutable";

import { defaultCharacterWidthMap } from "../../constants/characters";
import tutorialPaths from "../../tutorial/tutorialPaths";
import createFromJS from "../createFromJS";
import { AppStateRecord } from "./model/appState/AppStateRecord";
import { AutoUpdatesRecord } from "./model/autoUpdates/AutoUpdatesRecord";
import { TimelineDataRecord } from "./model/data/TimelineDataRecord";
import { TimelineDefinitionsRecord } from "./model/definitions/TimelineDefinitionsRecord";
import { DisplayCacheRecord } from "./model/display/DisplayCacheRecord";
import { FileConflictStateRecord } from "./model/fileConflicts/FileConflictStateRecord";
import { MobileScreenRecord } from "./model/mobileScreen/MobileScreenRecord";
import { PreferencesRecord } from "./model/preferences/PreferencesRecord";
import { RegistrationRecord } from "./model/registration/RegistrationRecord";
import { TimelineSyncRecord } from "./model/sync/TimelineSyncRecord";
import { TutorialRecord } from "./model/tutorial/TutorialRecord";
import { UIStateRecord } from "./model/uiState/UIStateRecord";
import { PrintOptionsRecord } from "./printing/PrintOptionsRecord";
import { TemplateDetailsRecord } from "./TemplateDetailsRecord";
import { WelcomeScreenRecord } from "./welcome/WelcomeScreenRecord";

export const TimelineRecord = Record({
  projectId: "",
  definitions: new TimelineDefinitionsRecord(),
  data: new TimelineDataRecord(),
  sync: new TimelineSyncRecord(),
  appState: new AppStateRecord(),
  uiState: new UIStateRecord(),
  display: new DisplayCacheRecord(),
  welcome: new WelcomeScreenRecord(),
  preferences: new PreferencesRecord(),
  printOptions: new PrintOptionsRecord(),
  autoUpdates: new AutoUpdatesRecord(),
  registration: new RegistrationRecord(),
  characterWidthMap: defaultCharacterWidthMap,
  isDataLoaded: false,
  activeTutorialPath: tutorialPaths.NEW_USER_NO_SYNC,
  templateDetails: new TemplateDetailsRecord(),
  tutorial: new TutorialRecord(),
  //#!if iOS === true
// fileConflicts: new FileConflictStateRecord(),
  //#!endif
  //#!if mobile === true || harvard === true
  mobileScreen: new MobileScreenRecord()
  //#!endif
});

const data = {
  objects: {
    data: "TimelineDataRecord",
    definitions: "TimelineDefinitionsRecord",
    sync: "TimelineSyncRecord",
    appState: "AppStateRecord",
    display: "DisplayCacheRecord",
    uiState: "UIStateRecord",
    welcome: "WelcomeScreenRecord",
    preferences: "PreferencesRecord",
    printOptions: "PrintOptionsRecord",
    autoUpdates: "AutoUpdatesRecord",
    registration: "RegistrationRecord",
    templateDetails: "TemplateDetailsRecord",
    tutorial: "TutorialRecord",
    //#!if iOS === true
// fileConflicts: "FileConflictStateRecord",
    //#!endif
    //#!if mobile === true
// mobileScreen: "MobileScreenRecord"
    //#!endif
  }
};

createFromJS.registerCallback("TimelineRecord", createFromJS.createNestedCallback(TimelineRecord, data));
